import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareAlignLeftIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 15 17' {...props}>
    <path
      d='M4 1v3H1V1h3zm1-1H0v5h5V0zM14 7v3h-3V7h3zm1-1h-5v5h5V6zM11 13v3H8v-3h3zm1-1H7v5h5v-5zM1 7H0v1h1V7zm0 3H0v1h1v-1zm0 3H0v1h1v-1zm0 3H0v1h1v-1zM4 7L2 8.5 4 10V9h5V8H4V7zM4 13l-2 1.5L4 16v-1h2v-1H4v-1z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M4 1v3H1V1h3zm1-1H0v5h5V0zM4 7v3H1V7h3zm1-1H0v5h5V6zM4 13v3H1v-3h3zm1-1H0v5h5v-5z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const AlignLeftIcon = memo(BareAlignLeftIcon);
